import React, { useEffect } from "react";
import Filter from "../components/Shop/FIlter/Filter";
import ShopingCard from "../components/Shop/ShopingCard/ShopingCard";
import ShoppingCardPopup from "../components/Shop/ShoppingCardPopup/ShoppingCardPopup";
import * as shopactions from "../actions/shop";
import * as headeractions from "../actions/header";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Preloader from "../components/Preloader/Preloader";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import DeliveryDate from "../components/DeliveryDate/DeliveryDate";
import "./scss/Shop.scss";

const Shop = (props) => {
  const { t } = useTranslation();

  document.title = `Gudema - ${t("shopPage.title")}`;

  const cleanParams = (params) => {
    const cleaned = { ...params };

    Object.keys(cleaned).forEach((key) => {
      if (
        cleaned[key] === "" ||
        cleaned[key] === null ||
        cleaned[key] === undefined
      ) {
        delete cleaned[key];
      }
    });

    return cleaned;
  };

  const {
    filterParams,
    specialOffer,
    getFlowers,
    getColors,
    getGroups,
    addSpecialOffer,
    changeReady,
  } = props;

  useEffect(() => {
    const params = cleanParams({
      ...filterParams,
      color: filterParams.color || "",
      groupId: filterParams.groupId || "",
      search: filterParams.search || "",
      sort: filterParams.sort ?? "",
      page: 0,
      pageNumber: 0,
    });

    if (specialOffer) {
      params.specialOffer = specialOffer;
    }

    getFlowers(params, null, true);
    getColors();
    getGroups();
    addSpecialOffer(null);

    return () => {
      changeReady(false);
      addSpecialOffer(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNext = () => {
    const nextPage = Number(props.pageNumber) + 1;

    props.getFlowers({
      ...props.filterParams,
      page: nextPage,
      pageNumber: nextPage,
    });
  };


  const isLoading = !props.flowers;

  return (
    <main className="shop-page">
      <section className="shop-content">
        <div className="shop-content__container">
          <div className="shop-content__head">
            <h2>{t("shopPage.title")}</h2>

            <DeliveryDate className="shop-delivery" />
          </div>

          <div className="shop-toolbar">
            <Filter
              colors={props.colors}
              groups={props.groups}
              filterParams={props.filterParams}
              getFlowers={props.getFlowers}
            />
          </div>

          {props.opened ? <ShoppingCardPopup {...props.card} /> : null}

          {isLoading || !props.isReady ? (
              <Preloader />
           ) : !props.flowers || props.flowers.length === 0 ? (
              <div className="shop-page__empty">
                {t("shopPage.empty")}
              </div>
            ) : (
              <InfiniteScroll
              dataLength={props.flowers.length}
              next={getNext}
              hasMore={
                Math.ceil(props.itemsTotal / 20) >
                Number(props.pageNumber) + 1
              }
              loader={<h4 className="shop-page__loading">{t("loading")}</h4>}
              endMessage=""
            >
              {props.flowers && props.flowers.length ? (
                <div className="shopingCard-wrap">
                  {props.flowers.map((fl, i) => (
                    <ShopingCard key={fl.id || i} {...fl} />
                  ))}
                </div>
              ) : (
                <div className="shop-page__empty">{t("shopPage.empty")}</div>
              )}
            </InfiniteScroll>
          )}
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  flowers: state.flowers.items,
  opened: state.shop.visible,
  card: state.shop.card,
  perPage: state.shop.perPage,
  page: state.shop.page,
  totalPages: state.shop.totalPages,
  pageNumber: state.shop.pageNumber,
  pages: state.shop.pages,
  isReady: state.shop.isReady,
  itemsTotal: state.shop.itemsTotal,
  filterParams: state.shop.filterParams,
  colors: state.shop.colors,
  groups: state.shop.groups,
  content: state.shop.content,
  specialOffer: state.header.specialOffer,
  authUsername: state.auth.authUsername,
  cart: state.shop.cart,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopactions, dispatch),
  ...bindActionCreators(headeractions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Shop);
